<template>
  <div>
    <component
      :is="loadField(field.field)"
      v-if="!isNested"
      :ref="field.key"
      :opts="fieldOptions"
    />
    <v-card v-else-if="isArray">
      <v-card-title>
        {{ field.name[$i18n.locale] }}
      </v-card-title>
      <v-flex>
        <v-row
          v-for="(answers, rowId) in answersList"
          :key="rowId"
          class="mb-0"
          :class="{'mb-8': answersList.length-1 !== rowId}"
        >
          <v-col>
            <v-row
              style="border-bottom: 2px solid transparent"
              class="align-center"
            >
              <v-col
                v-for="(childField, i) in field.children"
                :key="i"
                :cols="$vuetify.breakpoint.name === 'xs' ? 12 : 6"
              >
                <NestedField
                  :ref="childField.key"
                  :values="answers || {}"
                  :field="childField"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <div class="d-flex justify-space-between">
          <v-btn
            outlined
            @click="addAnswer()"
          >
            <v-icon> mdi-plus-circle-outline </v-icon>
          </v-btn>
          <v-btn
            v-if="answersList.length>1"
            outlined
            @click="removeAnswer()"
          >
            <v-icon>  mdi-bucket-outline </v-icon>
          </v-btn>
        </div>
      </v-flex>
    </v-card>
  </div>
</template>
<script>
import MdText from "@/components/ui/Text.vue";
import MdTextarea from "@/components/ui/Textarea.vue";
import MdSelect from "@/components/ui/Select.vue";
import MdCheckbox from "@/components/ui/Checkbox.vue";

export default {
  name: "NestedField",
  components: {
    MdText,
    MdSelect,
    MdCheckbox,
    MdTextarea,
  },
  props: {
    field: {
      type: Object,
      required: true,
    },
    values: {
      type: [Object, Array],
      required: true,
    },
  },
  data() {
    return {
      answersList: [{}],
    };
  },
  computed: {
    fieldOptions() {
      return typeof this.values[this.field.key] === 'object' && this.values[this.field.key] !== null
        ? { ...this.field, value: this.values[this.field.key].value }
        : { ...this.field, value: this.values[this.field.key] };
    },
    isNested() {
      return this.field.field === "object";
    },
    isArray() {
      return this.field.children;
    },
    loadField() {
      return (value) => "md-" + value;
    },
  },
  watch: {
    values: {
      handler(val) {
        const childrenAnswers = val[this.field.key];
        if (this.isArray && childrenAnswers && childrenAnswers.length) {
          this.answersList = childrenAnswers;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    addAnswer() {
      this.answersList.push({});
    },
    removeAnswer() {
      this.answersList.pop();
    },
  },
};
</script>
<style lang="scss">
.empty-place {
  width: 41px;
}
</style>
